<template>
<div class="add-form">
  <div class="add-form__close" @click.prevent="emit('close')">
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
      <path
          d="M15 5L5 15"
          stroke="#333333"
          stroke-linecap="round"
          stroke-linejoin="round"
      />
      <path
          d="M5 5L15 15"
          stroke="#333333"
          stroke-linecap="round"
          stroke-linejoin="round"
      />
    </svg>
  </div>
  <div class="add-form__title">Добавление интеграции</div>
  <VCustomInput v-model="form.accountName" class="add-form__input" :class="{'add-form__error': v$.accountName.$error}" placeholder="Название аккаунта*"/>
  <p class="add-form__inp-error" v-if="v$.accountName.$error">Заполните обязательное
    поле</p>
  <div class="add-form__inputs">
    <VCustomInput
        v-model="form.clientId"
        class="add-form__input"
        :class="{'add-form__error': v$.clientId.$error && props.addIntegrationsError}"
        placeholder="ID клиента*"
    />
    <VCustomInput
        v-model="form.clientSecretKey"
        class="add-form__input"
        :class="{'add-form__error': v$.clientSecretKey.$error && props.addIntegrationsError}"
        placeholder="Секретный ключ*"
    />
  </div>
  <div  class="add-form__inputs">
    <p class="add-form__inp-error" v-if="v$.clientId.$error && props.addIntegrationsError">{{props.addIntegrationsError}}</p>
    <p style="margin-left: auto" class="add-form__inp-error" v-if="v$.clientSecretKey.$error && props.addIntegrationsError">{{props.addIntegrationsError}}</p>
  </div>
  <div class="add-form__inputs">
    <a :href="url?.instructions?.avito" class="link-text add-form__link" target="_blank">Посмотреть инструкцию</a>
  </div>
  <div class="flex gap-4 w-full">
    <VButtonNew class="add-form__btn w-full" label="Сохранить" @click="add"/>
    <VButtonNew v-if="editData.id" class="add-form__btn w-full" style-type="secondary" label="Удалить"
                @click="emit('delete', {id: editData.id, name: editData.name, delete_id: editData.delete_id})"/>
  </div>
  <VButtonNew label="Отменить" style-type="grey" @click="emit('close')"/>
</div>
</template>
<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import useVuelidate from "@vuelidate/core";
import externalIntegrations from "@/api/externalIntegrations";
const emit = defineEmits(["close", "add", "delete"]);

const props = defineProps({
  addIntegrationsError: String,
  editData: Object,
})

const requiredField = (val) => {
  return !!val
}


const rules = computed(() => ({
  accountName: { requiredField },
  clientId: { requiredField },
  clientSecretKey: { requiredField }
}));

const form = reactive({
  accountName: '',
  clientId: '',
  clientSecretKey: ''
})

let v$ = useVuelidate(rules, form);


const add = async () => {
  const validate = await v$.value.$validate();
  if (!validate) {
    return
  }
  const args = {
    name: form.accountName,
    avito: {
      client_id: form.clientId,
      client_secret: form.clientSecretKey,
      override_webhook: true
    },
  }
  if(props.editData.name && props.editData.id) {
    args.override_webhook = true
    args.type = 'avito'
  }
  emit("add", args);
}

const url = ref('')

onMounted(async () => {
  if(props.editData.name && props.editData.id) {
    form.accountName = props.editData.name;
    form.clientId = props.editData.id;
    form.clientSecretKey = props.editData.client_secret;
  }
  url.value = await externalIntegrations.getUrlInstructions()
})
</script>
<style scoped lang="scss">
.add-form {
  padding: 24px;
  position: relative;
  text-align: center;

  :deep(.v-select__header-value) {
    text-align: left;
  }

  &__close {
    position: absolute;
    top: 12px;
    right: 16px;
    cursor: pointer;

    & svg path {
      stroke: #566a83;
    }
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 16px;
    margin-top: 16px;
  }

  &__input {
    margin-bottom: 12px;
    width: 100%;
  }

  &__error {
    border: solid 1px $red;
  }

  &__inputs {
    display: flex;
    gap: 12px;
  }

  &__link {
    color: $primary-main;
    margin-left: auto;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 24px;
  }

  &__btn {
    margin-bottom: 12px;
  }

  &__inp-error {
    margin-bottom: 12px;
    font-size: 14px;
    color: $red;
  }

  &__input-job-site {
    :deep(.v-select__header_disabled) {
      color: $gray!important;
    }

    :deep(.v-select__header-palceholder) {
      color: $gray!important;
    }

    :deep(.v-select__header-lock) {
      display: none;
    }
  }
}
</style>